import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import RequireAdmin from './components/admin/RequireAdmin';

import ManageBooking from './pages/ManageBooking';
import Landing from './pages/Landing';
import Confirmation from './pages/Confirmation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import NotFound from './pages/NotFound';
import WhatsNew from './pages/admin/WhatsNew';


const Login = lazy(() => import('./pages/Login'));
const AdminLayout = lazy(() => import('./components/admin/AdminLayout'));
const Operational = lazy(() => import('./pages/admin/Operational'));
const Records = lazy(() => import('./pages/admin/Records'));
const MessageHandler = lazy(() => import('./pages/admin/MessageHandler'));
const Trash = lazy(() => import('./pages/admin/Trash'));
const ScheduleManager = lazy(() => import('./pages/admin/ScheduleManager'));
const WalkinManager = lazy(() => import('./pages/admin/WalkinManager'));

function ScrollToTopOnNav({ children }) {
  const { pathname } = useLocation();
  React.useEffect(() => {
    if (pathname === '/') return;
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);
  return children;
}

function AdminFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--cream)',
        color: 'var(--plum-soft)',
        fontFamily: 'var(--font-display)',
        fontSize: 22,
        letterSpacing: '0.02em',
      }}
    >
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <ScrollToTopOnNav>
      <Suspense fallback={<AdminFallback />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/contactus" element={<Navigate to="/#contact" replace />} />
          <Route path="/confirmation/:appointmentId" element={<Confirmation />} />
          <Route path="/manage/:appointmentId" element={<ManageBooking />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />

          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<Navigate to="operations" replace />} />
            <Route path="operations" element={<Operational />} />
            <Route path="schedule" element={<ScheduleManager />} />
            <Route path="walkin" element={<WalkinManager />} />
            <Route path="records" element={<Records />} />
            <Route path="messages" element={<MessageHandler />} />
            <Route path="trash" element={<Trash />} />
            <Route path="whats-new" element={<WhatsNew />} />
          </Route>

          <Route path="/operations" element={<Navigate to="/admin/operations" replace />} />
          <Route path="/findrecords" element={<Navigate to="/admin/records" replace />} />
          <Route path="/messages" element={<Navigate to="/admin/messages" replace />} />
          <Route path="/trash" element={<Navigate to="/admin/trash" replace />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ScrollToTopOnNav>
  );
}